export default __webpack_public_path__ + "static/media/recruit-pg-2.ebdd6bed.png";